import { useEffect, useState } from 'react';
import './App.scss';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import data from './MQTT-STEP1-Data (Recieved from Broker-assessment_reportQoS)_v0.1_latest.json';
import { KeyOffTwoTone } from '@mui/icons-material';
import ObjectRenderer from './ObjectRenderer';
import mqtt from 'mqtt';
import remaLogo from './remalogo.svg';
import { IMAGES } from './image.js';
import Filtering from './Filtering.js';
import { useNavigate } from "react-router-dom";
import SpecificSubModelDetails from './SpecificDetails.js';
import FirstLevelCollection from './FirstLevelCollection.js';
import SecondLevelCollection from './SecondLevelCollction.js';
import SubmodelTree from './SubmodelTree.js';
import PropertyVis from './PropertyVis.js';
import { Resizable } from 're-resizable';
import Switch from '@mui/material/Switch';
import { alpha, styled } from '@mui/material/styles';
import Swal from 'sweetalert2';
import ReplyIcon from '@mui/icons-material/Reply';

function App() {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(true);
  const [label, setLabel] = useState("On");
  const [previousState, setPreviousState] = useState('');
  const [previousStateHighlight, setPreviousStateHighlight]=useState();

  const aasHost = process.env.REACT_APP_AAS_HOST;
  const aasReadPort = process.env.REACT_APP_AAS_READ_PORT;
  const syncPort = process.env.REACT_APP_SYNC_SERVICE_PORT || '3300';

  const normalizeSubDetails = (d) => {
    if (Array.isArray(d)) {
      const obj = {};
      d.forEach(item => {
        if (item?.idShort) obj[item.idShort] = normalizeSubDetails(item);
      });
      return obj;
    }
    if (d && typeof d === 'object' && 'idShort' in d) {
      if (Array.isArray(d.value)) {
        // Collection: hoist children directly, drop idShort/modelType wrapping
        return normalizeSubDetails(d.value);
      }
      // Property: return the primitive value directly — no object wrapper needed
      return d.value ?? null;
    }
    return d;
  };

  const getSubmodelId = (sm, shellId) => {
    const idShort = sm.idShort;
    // Use idShort only if it's a clean short name (no colons, no URL scheme)
    if (idShort && !idShort.includes(':') && !/^https?:\/\//.test(idShort)) return idShort;
    const raw = sm?.keys?.[0]?.value ?? idShort ?? '';
    const replaced = raw.replace('_' + shellId, '');
    if (replaced !== raw) return replaced;
    const parts = raw.split(':');
    return parts[parts.length - 1] || raw;
  };

  const isShortName = (s) => s && !s.includes(':') && !/^https?:\/\//.test(s);

  // Returns the best shell identifier for use in BaSyx API paths.
  // Prefers the shortest clean ID, falling back to nested asset idShort when
  // the top-level ids are URLs (common BaSyx data quality issue with Mo1).
  const getShellId = (asset) => {
    if (isShortName(asset.identification?.id)) return asset.identification.id;
    if (isShortName(asset.idShort)) return asset.idShort;
    if (isShortName(asset.id)) return asset.id;
    if (isShortName(asset.asset?.idShort)) return asset.asset.idShort;
    if (isShortName(asset.asset?.identification?.id)) return asset.asset.identification.id;
    return asset.identification?.id ?? asset.id ?? asset.idShort ?? '';
  };

  function goBackState()
  {
    setWeComeFromHierarchy(false)
    setReRender(current => !current)
    setImagetoShow("")
    setDetails()
    setSubDetails()
    var idShort = previousStateHighlight;
    var identificationID = previousState;
    const origIdentId = decodeURIComponent(identificationID);
    const shortId = /^https?:\/\//.test(origIdentId)
      ? origIdentId.split('/').filter(Boolean).pop()
      : origIdentId;
    set_Uuid_to_renderer(shortId);
    var identificationID_changed = encodeURIComponent(identificationID)
    fetch(
      `/aasServer/shells/${identificationID_changed}/aas/submodels`
    ).then(response => response.json()).then(data => {
      const arr = Array.isArray(data) ? data : Array.isArray(data?.entity) ? data.entity : Array.isArray(data?.result) ? data.result : [];
      const deduped = deduplicateSubmodels(arr, origIdentId);
      setDetails(deduped);
      const nameplateIdx = deduped.findIndex(sm => getSubmodelId(sm, origIdentId).toLowerCase() === 'nameplate');
      if (nameplateIdx !== -1) {
        const nm = deduped[nameplateIdx];
        const curSub = getSubmodelId(nm, origIdentId);
        setActive(nameplateIdx);
        setGlobalSubmodel(curSub);
        setWhatAreweLookingAt("SUB");
        setCurrentSubmodel(curSub);
        fetch(`/aasServer/shells/${identificationID_changed}/aas/submodels/${curSub}/submodel/values`)
          .then(async r => {
            const status = r.status;
            const json = await r.json();
            if (status === 200) { setSubDetails(normalizeSubDetails(json)); }
            else if (status === 500) {
              fetch(`/aasServer/shells/${identificationID_changed}/aas/submodels/${curSub}/submodel/submodelElements`)
                .then(r2 => r2.json()).then(d => setSubDetails(normalizeSubDetails(d)));
            }
          })
          .catch(err => console.error("Failed to load Nameplate:", err));
      }
    });

    setCurrentAsset(identificationID_changed)
    setPreviousState(identificationID_changed)
    setSelectedAsset(idShort);
  }
  const handleChange = (event) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      setLabel("On")
    }
    else { setLabel("Off") }
  };
  const PinkSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: "#fff",
      '&:hover': {
        backgroundColor: alpha("#269044", theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: "#269044",
    },
  }));

  //console.log(IMAGES)
  var fixedForTExt;

  const [msg, setMsg] = useState("")
  const [myTopic, setmyTopic] = useState("")

  const [parentState, setParentState] = useState(true);

  const handleChildAction = () => {
    // Update state which will trigger re-render
    setParentState(current => !current);
  };

  ////--------------------------THIS IS AN MQTTT CALL AND MIGHT BE NEEDED LATER ON--------------------//


  // useEffect(() => {
  //   var options = {
  //     protocol: 'websockets',
  //     clientId: 'string1234' //This can be any unique id
  //   }
  //   var client = mqtt.connect('ws://${baseURL}:8083/mqtt', options)
  //   client.subscribe('ct/com/ids/aas/OmniVerse_CircularTwAIn_Simulation/QualityClassification_and_Assessment/assessment_report')
  //   client.subscribe('ct/com/ids/aas/OmniVerse_CircularTwAIn_Simulation/QualityClassification_and_Assessment/quality_classification')


  //   client.on('message', function (topic, message) {

  //     try {
  //       // Attempt to parse the message as JSON
  //       var parsedMessage = JSON.stringify(message.toString());

  //       //console.log(message )
  //       setMsg(message)
  //       setmyTopic(topic)
  //       console.log(myTopic)
  //     } catch (error) {
  //       // Log as a string if parsing fails

  //       console.log(message.toString() + `${topic}` + "hello");
  //       setmyTopic(topic)
  //       setMsg(message)
  //       console.log(myTopic)

  //     }

  //   })

  // }, [])

  //STAFF FOR MQTT//



  ////--------------------------THIS IS AN MQTTT CALL AND MIGHT BE NEEDED LATER ON--------------------//


  var incomingData = data.discovery_report;
  var uuID;
  useEffect(() => {
    if (msg !== "") {

      console.log((msg.toString()))


      if (myTopic === "ct/com/ids/aas/OmniVerse_CircularTwAIn_Simulation/QualityClassification_and_Assessment/assessment_report") {
        var trial = msg.toString()
        console.log("TRIAL:", JSON.parse(trial))
        var sec = JSON.parse(trial)


        if (typeof sec.assessment_report === "undefined") {
          console.log("FROM TOPIC 1:", sec.discovery_report)
          incomingData = sec.discovery_report
          uuID = `7165398751379457`;
          console.log("FROM TOPIC 1:", uuID, sec.id)
        }
        else if (typeof sec.discovery_report === "undefined") {
          console.log("FROM TOPIC 2:", sec.assessment_report)
          incomingData = sec.assessment_report.discovery_report
          uuID = `7165398751379458`;
          console.log("FROM TOPIC 2:", uuID, sec.assessment_report.id)

        }

        console.log("INCOMINGDATA:", incomingData)
        //fixDataForBasyx();
      }
    }

  }, [msg])


  //console.log(incomingData)
  const [youDo, setYouDo] = useState([]);
  const [id, setID] = useState("hardcoded ID")
  const [name, setName] = useState("")
  const [reRender, setReRender] = useState(true);
  const [details, setDetails] = useState();
  const [detailsForText, setDetailsForText] = useState();
  const [currentAsset, setCurrentAsset] = useState();
  const [currentSubmodel, setCurrentSubmodel] = useState();
  const [subDetails, setSubDetails] = useState();
  const [isActive, setActive] = useState(-1);
  const [policyIDstate, setPolicyIDstate] = useState("")
  const [contractIDstate, setContractIDstate] = useState("")


  var diti = {}
  var idShort;
  var uuID;
  var emptySubmodel = {};
  var infoNameplate = {};
  var infoBOM = {};
  var images = IMAGES;
  var images_value = [];

  const [weComeFromHierarchy, setWeComeFromHierarchy]=useState(false)

  const [allHiddenState, setAllHiddenState] = useState(false);

  function sendHierarchyToApp(value) {
    setWeComeFromHierarchy(true)
    setReRender(current => !current)
    setImagetoShow("")
    setDetails()
    setSubDetails()

    // value may be an idShort (e.g. "squirrelCage_Mo1") or a full identification.id URI
    // Try exact identification.id match first, then fall back to idShort match
    const matchedAsset =
      youDo.find(item => getShellId(item) === value) ||
      youDo.find(item => item.identification?.id === value) ||
      youDo.find(item => item.idShort === value);

    const identificationID = matchedAsset ? getShellId(matchedAsset) : value;
    const shortId = /^https?:\/\//.test(identificationID)
      ? identificationID.split('/').filter(Boolean).pop()
      : identificationID;

    set_Uuid_to_renderer(shortId);
    const identificationID_changed = encodeURIComponent(identificationID);

    const autoSelect = (submodelsArr, shellId) => {
      const deduped = deduplicateSubmodels(submodelsArr, identificationID);
      setDetails(deduped);
      const nameplateIdx = deduped.findIndex(sm => getSubmodelId(sm, identificationID).toLowerCase() === 'nameplate');
      if (nameplateIdx !== -1) {
        const nm = deduped[nameplateIdx];
        const curSub = getSubmodelId(nm, identificationID);
        setActive(nameplateIdx);
        setGlobalSubmodel(curSub);
        setWhatAreweLookingAt("SUB");
        setCurrentSubmodel(curSub);
        fetch(`/aasServer/shells/${shellId}/aas/submodels/${curSub}/submodel/values`)
          .then(async r => {
            const status = r.status;
            const json = await r.json();
            if (status === 200) { setSubDetails(normalizeSubDetails(json)); }
            else if (status === 500) {
              fetch(`/aasServer/shells/${shellId}/aas/submodels/${curSub}/submodel/submodelElements`)
                .then(r2 => r2.json()).then(d => setSubDetails(normalizeSubDetails(d)));
            }
          })
          .catch(err => console.error("Failed to load Nameplate:", err));
      }
    };

    // Use embedded submodels from youDo first (same as left-panel click), fall back to HTTP
    const embedded = matchedAsset?.submodels;
    if (Array.isArray(embedded) && embedded.length > 0) {
      autoSelect(embedded, identificationID_changed);
    } else {
      fetch(
        `/aasServer/shells/${identificationID_changed}/aas/submodels`
      ).then(response => {
        if (!response.ok) {
          Swal.fire({
            title: 'Error!',
            text: 'This particular asset has been removed',
            icon: 'error',
            confirmButtonText: 'OK'
          })
          return;
        } return response.json()
      }).then(data => {
        if (!data) return;
        const arr = Array.isArray(data) ? data : Array.isArray(data?.entity) ? data.entity : Array.isArray(data?.result) ? data.result : [];
        autoSelect(arr, identificationID_changed);
      });
    }

    setCurrentAsset(identificationID_changed)
    setSelectedAsset(identificationID);
    setSelectedCategory("All");
  }

  


  const [currentAssetSubmodels, setCurrentAssetSubmodels] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [uuid_send_to_renderer, set_Uuid_to_renderer] = useState("mimis");

  const[finalRenderingSubmodels ,setFinalRenderingSubmodels]=useState([])

  useEffect(() => {
    const fetchSubmodelDetails = async () => {
   
      try {
        const fetchPromises = currentAssetSubmodels.flatMap((curSubmodelArray) => {
          return curSubmodelArray.map((curSubmodel) => {
            const rawVal = curSubmodel?.keys?.[0]?.value || '';
            const id = curSubmodel.idShort || rawVal.replace('_' + decodeURIComponent(currentAsset), '');
            if (!id) return Promise.resolve({ id: null, isEmpty: true });
            return fetch(
              `/aasServer/shells/${currentAsset}/aas/submodels/${id}/submodel/submodelElements`
            )
              .then(r => r.json())
              .then(data => {
                const arr = Array.isArray(data) ? data
                  : Array.isArray(data?.entity) ? data.entity
                  : Array.isArray(data?.result) ? data.result
                  : [];
                const isEmpty = arr.length === 0 || arr.every(el => isAllEmpty(el?.value));
                return { id, isEmpty };
              })
              .catch(() => ({ id, isEmpty: false }));
          });
        });

        const results = await Promise.all(fetchPromises);
        setFinalRenderingSubmodels(results);
      } catch (error) {
        console.error("Error fetching submodel details:", error);
      }
    };

    if (currentAssetSubmodels.length > 0) {
      fetchSubmodelDetails();
    }

  }, [currentAssetSubmodels]); 

  
  

  function clickedShowIcon(e) {
    setWeComeFromHierarchy(false)
    setReRender(current => !current)
    setImagetoShow("")
    setDetails()
    setSubDetails()
    var idShort = e.currentTarget.parentNode.children[0].children[0].innerText;
    var identificationID = e.currentTarget.parentNode.children[0].children[1].innerText;
    console.log(idShort, identificationID);
    set_Uuid_to_renderer(identificationID);
    var identificationID_changed = encodeURIComponent(identificationID)
    
    fetchAndAppend(identificationID_changed).then(results => {
        console.log('All fetched results:', results);
        setCurrentAssetSubmodels(results);
      });
      
    
    console.log(identificationID_changed)

    // BaSyx 1.4.0 embeds submodels in the shell object from /aasServer/shells.
    // Use that data first to avoid the separate submodels endpoint which returns 404.
    const shell = youDo.find(item =>
      item.identification?.id === identificationID || item.idShort === idShort
    );
    console.log("Shell from youDo:", shell);

    const embedded = shell?.submodels;
    if (Array.isArray(embedded) && embedded.length > 0) {
      setDetails(deduplicateSubmodels(embedded, identificationID));
    } else {
      fetch(
        `/aasServer/shells/${identificationID_changed}/aas/submodels`
      ).then(response => response.json()).then(data => {
        const arr = Array.isArray(data) ? data : Array.isArray(data?.entity) ? data.entity : Array.isArray(data?.result) ? data.result : [];
        setDetails(deduplicateSubmodels(arr, identificationID));
      });
    }

    console.log(details)
    setCurrentAsset(identificationID_changed)
    setPreviousState(identificationID_changed)
    setSelectedAsset(identificationID);
    setPreviousStateHighlight(identificationID);
    // setSelectedCategory("All");
  }



  async function clickedDeleteIcon(e) {
    setImagetoShow("")
    setDetails()
    setSubDetails()
    var idDelete = e.currentTarget.parentNode.children[0].children[1].innerText;
    var x = encodeURIComponent(idDelete);


    const say = await fetch(
      `/aasServer/shells/${x}`, {
      method: "DELETE",
    })//setInfo(data)

    const result = await say.status;
    if (result === 200) {
      Swal.fire({
        title: 'Successful Deletion',
        text: 'This particular asset has been successfully removed',
        icon: 'success',
        confirmButtonText: 'OK'
      })
      setReRender(current => !current)
    }
    else {
      console.log(result)
    }

  }



  const [trialArraySubDetails, setTrialArraySubDetails] = useState([]);

  const [globalSubModel, setGlobalSubmodel] = useState("");


  
  async function fetchAndAppend(id) {
    const results = [];
    if (id) {
      const decodedId = decodeURIComponent(id);
      const shell = youDo.find(item =>
        item.identification?.id === decodedId || item.idShort === decodedId
      );
      const embedded = shell?.submodels;
      if (Array.isArray(embedded) && embedded.length > 0) {
        results.push(embedded);
      } else {
        try {
          const response = await fetch(`/aasServer/shells/${encodeURIComponent(decodedId)}/aas/submodels`);
          const data = await response.json();
          const normalized = Array.isArray(data) ? data : Array.isArray(data?.entity) ? data.entity : Array.isArray(data?.result) ? data.result : [];
          results.push(normalized);
        } catch (error) {
          console.error(`Failed to fetch data for ID: ${id}`, error);
        }
      }
    }
    return results;
  }
  
  
  

  async function showSubmodelsDets(e, i) {
    setImagetoShow("")
    setWhatAreweLookingAt("SUB")
    setActive(i);
    var curSubmodel = getSubmodelId(details[i], decodeURIComponent(currentAsset));
    setGlobalSubmodel(curSubmodel);

    fetch(
      `/aasServer/shells/${currentAsset}/aas/submodels/${curSubmodel}/submodel/values`
    ).then(response => response.json()).then(data => setSubDetails(normalizeSubDetails(data)));

    setCurrentSubmodel(curSubmodel)

    //console.log("My subdetes",subDetails)


    for (let subKeys in subDetails) {

      console.log("MHM", subKeys, ":", subDetails[subKeys])
      for (let innerKeys in subDetails[subKeys].attributes) {
        var innerKeys2;
        var attributeValue = Object.keys(subDetails[subKeys].attributes);
        //console.log("Condition result:", attributeValue);
        for (let i = 0; i < attributeValue.length; i++) {
          //console.log("Condition result:", attributeValue[i])
          if (attributeValue[i].includes('manufa')) {
            //console.log("WE HERE", attributeValue[i])
            innerKeys2 = "manufacturer"
          }
        }

        console.log(innerKeys2, ":", subDetails[subKeys].attributes[innerKeys])

        //something[innerKeys2]=subDetails[subKeys].attributes[innerKeys]

      }

    }

  }


  //###################   WS STAFF #################################//
  const wsHost = process.env.REACT_APP_WS_HOST;
  const wsPort = process.env.REACT_APP_WS_PORT;
  const [message, setMessage] = useState('');
  var letMsg = ''
  useEffect(() => {
    let socket;
    const connect = () => {
      const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      socket = new WebSocket(`${wsProtocol}//${window.location.host}/ws`);

      socket.onopen = () => {
        console.log('WebSocket connection established');
      };

      socket.onmessage = (event) => {
        console.log('Received message:', event.data);
        // Use a function updater to ensure previous state is not overwritten
        setMessage(prevMessages => {
          const newMessages = [...prevMessages, event.data];  // Append new message
          return newMessages;
        });

        // Use the current timestamp or a unique value for triggering rerenders
        setReRender(Date.now());
      };

      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

      socket.onclose = (event) => {
        console.log(`WebSocket connection closed: ${event.code} - ${event.reason}`);
        console.log('Was clean?', event.wasClean);

        // Attempt to reconnect after a delay
        setTimeout(() => {
          console.log('Reconnecting...');
          connect();
        }, 5000); // Retry after 5 seconds
      };
    };

    connect(); // Initial connection

    return () => {
      console.log('Closing socket');
      if (socket) {
        socket.close();
      }
    };
  }, []);

  const assetShowing = () => {
    fetch(`/aasServer/shells`)
      .then(response => response.json())
      .then(data => {
        const shells = Array.isArray(data) ? data : (data?.result ?? []);
        setYouDo(shells);
      })
      .catch(error => console.error('Error fetching data:', error));
  };

  useEffect(() => {
    assetShowing();
  }, [message, reRender, parentState]); //fixed rerendering with key on the div part

  // useEffect(() => {
  //   assetShowing(); 
  // }, [reRender, youDo])//    ====>>>> This worked before now we do with the websocket
  //whenever  new message is send by the expres server that updates the assets we re render




  const [imagetoShow, setImagetoShow] = useState("");
  function sendClick(id) {
    setImagetoShow(images[id].quality_classification.image)
    console.log("CLICK", id)
  }

  //used in all visualizations to identify which case is it (0 lvlv , 1st lvl, 2nd lvl, or property)
  const [whatAreWeLookingAt, setWhatAreweLookingAt] = useState("");
  //used oin 1st level
  const [numOfAttributes, setNumofAttributes] = useState(0);
  const [listOfSecondLvlSub, setListOfSecondLvlSub] = useState([]);
  const [listOfProperties, setListOfProperties] = useState([]);
  const [currentSubelementCollection, setCurrentSubelementCollection] = useState("");

  //used in second level
  const [length, setLength] = useState(0);
  const [secSubEle, setSecSubEele] = useState("");
  const [parentSub, setParentSub] = useState("");
  //used in PropertyVis
  const [parentName, setParentName] = useState("");
  const [propertyName, setPropertyName] = useState("");
  const [propertyValue, setPropertyValue] = useState("");


  function sendCurrentClicked(key) {
    console.log("CLICKED APP", key, currentAsset, currentSubmodel)
    if (!key.includes(".")) {
      //alert("FIRST LEVEL Collection")

      fetchStaffData(currentAsset, currentSubmodel, key)
      setWhatAreweLookingAt("FIRSTSUB")

    }
    if (key.includes(".")) {
      //alert("Second LEVEL Collection")
      if ((key.match(/\./g) || []).length >= 2) {
        fetchStaffDataInnerInner(currentAsset, currentSubmodel, key.split(".")[0], key.split(".")[1], key.split(".")[2])
      }
      else {
        fetchStaffDataInner(currentAsset, currentSubmodel, key.split(".")[0], key.split(".")[1]);
        setWhatAreweLookingAt("SECONDSUB");
      }

    }
  }




  //// ---------------   Category listing Staff -------------------------////
  const [selectedCategory, setSelectedCategory] = useState('All');
  // State to manage the categories in the dropdown
  const [categories, setCategories] = useState([]);

  // Update the categories list whenever `youDo` changes
  useEffect(() => {
    const cats = youDo.map(a => a.category ?? a.asset?.category ?? a.assetInformation?.assetType).filter(Boolean);
    const uniqueCategories = new Set(['All', ...cats]);
    setCategories(Array.from(uniqueCategories));
  }, [youDo, message]);

  // Function to handle category change
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };


  const [searchQuery, setSearchQuery] = useState('');

  // Filter assets based on the selected category
  const filteredAssets = youDo
    .filter(instance => selectedCategory === 'All' || (instance.category ?? instance.asset?.category ?? instance.assetInformation?.assetType) === selectedCategory)
    .filter(instance => !searchQuery || instance.idShort?.toLowerCase().includes(searchQuery.toLowerCase()));

  useEffect(() => { }, [parentState])
  const [saw, setSaw] = useState(false)

  function clickedShowIconDirect(idShort, identificationID) {
    setWeComeFromHierarchy(false);
    setReRender(current => !current);
    setImagetoShow("");
    setDetails();
    setSubDetails();
    // Use idShort (the short asset name) as the identifier for write/upgrade calls
    const shortId = /^https?:\/\//.test(identificationID)
      ? identificationID.split('/').filter(Boolean).pop()
      : identificationID;
    set_Uuid_to_renderer(shortId);
    const identificationID_changed = encodeURIComponent(identificationID);
    fetchAndAppend(identificationID_changed).then(results => setCurrentAssetSubmodels(results));
    const shell = youDo.find(item => item.identification?.id === identificationID || item.idShort === idShort);
    const embedded = shell?.submodels;

    const loadAndAutoSelectNameplate = (submodelsArr, shellId) => {
      const deduped = deduplicateSubmodels(submodelsArr, identificationID);
      setDetails(deduped);
      const nameplateIdx = deduped.findIndex(sm => getSubmodelId(sm, identificationID).toLowerCase() === 'nameplate');
      if (nameplateIdx !== -1) {
        const nm = deduped[nameplateIdx];
        const curSub = getSubmodelId(nm, identificationID);
        setActive(nameplateIdx);
        setGlobalSubmodel(curSub);
        setWhatAreweLookingAt("SUB");
        setCurrentSubmodel(curSub);
        fetch(`/aasServer/shells/${shellId}/aas/submodels/${curSub}/submodel/values`)
          .then(async r => {
            const status = r.status;
            const json = await r.json();
            if (status === 200) { setSubDetails(normalizeSubDetails(json)); }
            else if (status === 500) {
              fetch(`/aasServer/shells/${shellId}/aas/submodels/${curSub}/submodel/submodelElements`)
                .then(r2 => r2.json()).then(d => setSubDetails(normalizeSubDetails(d)));
            }
          })
          .catch(err => console.error("Failed to load Nameplate:", err));
      }
    };

    if (Array.isArray(embedded) && embedded.length > 0) {
      loadAndAutoSelectNameplate(embedded, identificationID_changed);
    } else {
      fetch(`/aasServer/shells/${identificationID_changed}/aas/submodels`)
        .then(r => r.json()).then(data => {
          const arr = Array.isArray(data) ? data : Array.isArray(data?.entity) ? data.entity : Array.isArray(data?.result) ? data.result : [];
          loadAndAutoSelectNameplate(arr, identificationID_changed);
        });
    }
    setCurrentAsset(identificationID_changed);
    setPreviousState(identificationID_changed);
    setSelectedAsset(identificationID);
    setPreviousStateHighlight(identificationID);
  }

  async function clickedDeleteIconDirect(identificationID) {
    setImagetoShow("");
    setDetails();
    setSubDetails();
    const x = encodeURIComponent(identificationID);
    const say = await fetch(`/aasServer/shells/${x}`, { method: "DELETE" });
    const result = await say.status;
    if (result === 200) {
      Swal.fire({ title: 'Successful Deletion', text: 'This particular asset has been successfully removed', icon: 'success', confirmButtonText: 'OK' });
      setReRender(current => !current);
    }
  }

  return (
    <div className="App" >
      {/* {saw?<Filtering/>:<></>} */}
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        {/* Header and Navigation */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px", backgroundColor: "#fff", borderBottom: "1px solid #d3d3d3", height: "60px", position: "sticky", top: 0, zIndex: 1030, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "0 24px" }}>
          <img src={remaLogo} style={{ height: "26px", display: "block" }} alt="RemaNet" />
          <div style={{ width: "1px", height: "22px", background: "#e0e0e0", flexShrink: 0 }} />
          <span style={{ fontSize: "13px", color: "#7c7c7c", fontWeight: "500", letterSpacing: "0.02em" }}>DataSpace Explorer</span>
        </div>

        <div style={{ display: "flex", backgroundColor: "#fff", borderBottom: "1px solid #d3d3d3", padding: "0 16px" }}>
          <button style={{ fontSize: "13px", fontWeight: "600", cursor: "pointer", color: "#269044", padding: "0 16px", height: "40px", background: "none", border: "none", borderBottom: "2px solid #269044", marginBottom: "-1px" }} onClick={() => navigate("/")}>DT Explorer</button>
          <button style={{ fontSize: "13px", fontWeight: "600", cursor: "pointer", color: "#7c7c7c", padding: "0 16px", height: "40px", background: "none", border: "none", borderBottom: "2px solid transparent", marginBottom: "-1px" }} onClick={() => navigate("/sync")}>Product DT-DS</button>
          <button style={{ fontSize: "13px", fontWeight: "600", cursor: "pointer", color: "#7c7c7c", padding: "0 16px", height: "40px", background: "none", border: "none", borderBottom: "2px solid transparent", marginBottom: "-1px" }} onClick={() => navigate("/dataspace")}>DS Management</button>
        </div>
        <div classNme="inner_des" style={{ display: "flex", flex: 3, backgroundColor: "#f1f1f1" }}>

          {/* <div className='left_slider'></div> */}
          {youDo.length > 0 ?
            <div>
              <Resizable>
                <div className='assets_view' >{/*here we add the resizable */}
                  <div style={{ padding: "10px 14px 8px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", color: "#7c7c7c" }}>Available Assets</span>
                    <span style={{ background: "#f1f1f1", border: "1px solid #d3d3d3", borderRadius: "10px", padding: "1px 7px", fontSize: "11px", fontWeight: "600", color: "#7c7c7c" }}>{filteredAssets.length}</span>
                  </div>
                  <div style={{ height: "1px", width: "100%", background: "#d3d3d3" }} />

                  <div style={{ position: "relative", padding: "8px 10px 4px" }}>
                    <svg style={{ position: "absolute", left: "18px", top: "50%", transform: "translateY(-50%)", color: "#aaa", pointerEvents: "none", display: "block" }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                    <input
                      type="text"
                      placeholder="Search assets…"
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      style={{ width: "100%", padding: "5px 10px 5px 30px", border: "1px solid #d3d3d3", borderRadius: "6px", fontSize: "12px", color: "#202020", background: "#f8f8f8", outline: "none" }}
                    />
                  </div>

                  <div style={{ display: "flex", gap: "4px", padding: "4px 10px 8px", flexWrap: "wrap" }}>
                    {categories.map(cat => (
                      <span
                        key={cat}
                        onClick={() => handleCategoryChange(cat)}
                        style={{
                          padding: "3px 10px", borderRadius: "12px", fontSize: "11px", fontWeight: "600",
                          cursor: "pointer",
                          border: "1px solid " + (selectedCategory === cat ? "rgba(38,144,68,0.35)" : "#d3d3d3"),
                          color: selectedCategory === cat ? "#269044" : "#7c7c7c",
                          background: selectedCategory === cat ? "rgba(38,144,68,0.08)" : "#fff",
                        }}
                      >{cat}</span>
                    ))}
                  </div>

                  <div key={message}>
                    {filteredAssets
                      .sort((a, b) => (getShellId(a) === selectedAsset ? -1 : getShellId(b) === selectedAsset ? 1 : 0))
                      .map((asset) => {
                        const sid = getShellId(asset);
                        return (
                        <div
                          key={sid}
                          className={"single_asset" + (sid === selectedAsset ? " selected" : "")}
                          style={{
                            backgroundColor: sid === selectedAsset ? 'rgba(38, 144, 68, 0.08)' : '',
                            borderColor: sid === selectedAsset ? '#269044' : '',
                          }}
                        >
                          <div style={{ width: "7px", height: "7px", borderRadius: "50%", background: sid === selectedAsset ? "#269044" : "#d3d3d3", flexShrink: 0, transition: "background 0.15s" }} />
                          <div className="asset_title">
                            <div>{asset.idShort ?? asset.id}</div>
                            <div style={{ fontSize: '11px' }}>{asset.category ?? asset.asset?.category ?? asset.assetInformation?.assetType ?? ''}</div>
                          </div>
                          <div className="asset_actions">
                            <div className="show_icon" onClick={() => clickedShowIconDirect(asset.idShort ?? asset.id, sid)}>
                              <RemoveRedEyeIcon />
                            </div>
                            <div className="delete_icon" onClick={() => clickedDeleteIconDirect(sid)}>
                              <DeleteIcon />
                            </div>
                          </div>
                        </div>
                        );
                      })}
                  </div>
                </div>
              </Resizable>
            </div> : <div style={{ height: "90vh" }}></div>}

          <Resizable className='resizable_app'
            handleClasses={{
              top: "pointer-events-none",
              bottom: "pointer-events-none",
              left: "pointer-events-none",
              topRight: "pointer-events-none",
              bottomRight: "pointer-events-none",
              bottomLeft: "pointer-events-none",
              topLeft: "pointer-events-none",
            }}>
            <div className="asset_details_outer">
              <div style={{ padding: "10px 14px 8px", display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
                <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", color: "#7c7c7c" }}>AAS & Elements</span>
                {selectedAsset && (() => {
                  const assetName = youDo.find(a => getShellId(a) === selectedAsset)?.idShort || youDo.find(a => getShellId(a) === selectedAsset)?.id || selectedAsset;
                  return (
                    <>
                      <span style={{ color: "#d3d3d3", fontSize: "14px" }}>›</span>
                      <span style={{ fontSize: "13px", fontWeight: "600", color: "#269044" }}>{assetName}</span>
                    </>
                  );
                })()}
              </div>

              {details && (
                <div style={{ display: "flex", overflowX: "auto", padding: "0 12px", gap: "2px", flexShrink: 0, borderBottom: "1px solid #d3d3d3", alignItems: "flex-end" }}>
                  {details.map((submodel, i) => {
                    const label = getSubmodelId(submodel, decodeURIComponent(currentAsset));
                    const resultForId = finalRenderingSubmodels.find(r => r.id === label);
                    if (!checked && resultForId?.isEmpty === true) return null;
                    return (
                      <div
                        key={i}
                        onClick={(e) => showSubmodelsDets(e, i)}
                        style={{
                          padding: "8px 14px",
                          fontSize: "12px", fontWeight: "600",
                          cursor: "pointer",
                          color: isActive === i ? "#269044" : "#7c7c7c",
                          borderBottom: isActive === i ? "2px solid #269044" : "2px solid transparent",
                          background: "none",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                          transition: "color 0.15s, border-color 0.15s",
                        }}
                        onMouseEnter={e => { if (isActive !== i) e.currentTarget.style.color = "#202020"; }}
                        onMouseLeave={e => { if (isActive !== i) e.currentTarget.style.color = "#7c7c7c"; }}
                      >
                        {label}
                      </div>
                    );
                  })}
                  {weComeFromHierarchy && (
                    <div className="hierarchy_div" style={{ alignSelf: "center", marginLeft: "4px", marginBottom: "4px" }} onClick={goBackState}><ReplyIcon /></div>
                  )}
                </div>
              )}

              <div style={{ padding: "5px 14px", display: "flex", alignItems: "center", borderBottom: "1px solid #d3d3d3", flexShrink: 0 }}>
                <span style={{ color: "#7c7c7c", fontSize: "12px", fontWeight: "500" }}>Show Empty Values </span>
                <PinkSwitch checked={checked} onChange={handleChange} defaultChecked />
              </div>

              <div className='asset_details' style={{ flex: 1, overflow: "auto", display: "block" }}>
                {subDetails ?
                  <ObjectRenderer onAction={handleChildAction} data={subDetails} sendCurrentClicked={sendCurrentClicked} sendClick={sendClick} uuid_from_main={uuid_send_to_renderer} submodel_from_main={currentSubmodel} toggleState={checked} sendHierarchyToApp={sendHierarchyToApp}/>
                : <></>}
              </div>
            </div>
          </Resizable>

          <div className='asset_manipulation'>
            <div style={{ padding: "12px 16px 8px", display: "flex", alignItems: "center" }}>
              <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", color: "#7c7c7c" }}>Elements</span>
            </div>
            <div style={{ height: "1px", width: "100%", background: "#d3d3d3" }} />
            {globalSubModel !== "" && subDetails ? (
              <div style={{ width: "100%", marginRight: "40%" }}>
                {whatAreWeLookingAt === "SUB" && (
                  <SubmodelTree
                    name={globalSubModel}
                    data={subDetails}
                  />
                )}

                {whatAreWeLookingAt === "SECONDSUB" && (
                  <SecondLevelCollection
                    parentSub={parentSub}
                    secSubEle={secSubEle}
                    listOfProperties={listOfProperties}
                    listOfSecondLvlSub={listOfSecondLvlSub}
                  />
                )}

                {whatAreWeLookingAt === "FIRSTSUB" && (
                  <FirstLevelCollection
                    currentSubelementCollection={currentSubelementCollection}
                    numOfAttributes={numOfAttributes}
                    listOfSecondLvlSub={listOfSecondLvlSub}
                    listOfProperties={listOfProperties}
                  />
                )}
                {whatAreWeLookingAt === "PROPERTY" && (
                  <PropertyVis
                    parentName={parentName}
                    propertyName={propertyName}
                    propertyValue={propertyValue}
                  />
                )}
              </div>
            ) : null}

            {/* {msg} */}
          </div>

          {/* <div className='right_slider'>

        </div> */}
        </div>
      </div>

      {/* END DIV App */}
    </div>
  );

  function fetchStaffData(currentAsset, currentSubmodel, key) {
    // Initialize counters and array for storing idShort values
    let propertyCount = 0;
    let collectionCount = 0;
    let collectionIdShorts = [];

    fetch(
      `/aasServer/shells/${currentAsset}/aas/submodels/${currentSubmodel}/submodel/submodelElements/${key}`
    )
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error fetching data: ${response.statusText}`);
        }
        return response.json();  // Parse the response to JSON
      })
      .then(data => {
        // Check if 'value' is an array
        if (Array.isArray(data.value)) {
          const propertyItems = [];
          data.value.forEach(item => {
            if (item.modelType && item.modelType.name) {
              if (item.modelType.name === 'Property') {
                propertyCount++;
                propertyItems.push({ name: item.idShort, value: item.value ?? null });
              }
              if (item.modelType.name === 'SubmodelElementCollection') {
                collectionCount++;
                collectionIdShorts.push(item.idShort);
              }
            }
          });
          setListOfProperties(propertyItems);
        } else {
          setWhatAreweLookingAt("PROPERTY")
          setParentName(currentSubmodel)
          setPropertyName(key)
          setPropertyValue(data.value)
        }

        setNumofAttributes(propertyCount)
        setCurrentSubelementCollection(key)
        setListOfSecondLvlSub(collectionIdShorts)
      })
      .catch(error => {
        console.error("Failed to fetch data:", error);
      });
  }

  function fetchStaffDataInner(currentAsset, currentSubmodel, key, key1) {


    fetch(
      `/aasServer/shells/${currentAsset}/aas/submodels/${currentSubmodel}/submodel/submodelElements/${key}/${key1}/value`
    )
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error fetching data: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          const propertyItems = [];
          const collectionIdShorts = [];
          data.forEach(item => {
            if (item.modelType && item.modelType.name) {
              if (item.modelType.name === 'Property') {
                propertyItems.push({ name: item.idShort, value: item.value ?? null });
              }
              if (item.modelType.name === 'SubmodelElementCollection') {
                collectionIdShorts.push(item.idShort);
              }
            }
          });
          setLength(data.length);
          setParentSub(key);
          setSecSubEele(key1);
          setListOfProperties(propertyItems);
          setListOfSecondLvlSub(collectionIdShorts);
        } else {
          setWhatAreweLookingAt("PROPERTY")
          setParentName(key)
          setPropertyName(key1)
          setPropertyValue(data)
        }
      })
      .catch(error => {
        console.error("Failed to fetch data:", error);
      });
  }

  function fetchStaffDataInnerInner(currentAsset, currentSubmodel, key, key1, key2) {
    fetch(
      `/aasServer/shells/${currentAsset}/aas/submodels/${currentSubmodel}/submodel/submodelElements/${key}/${key1}/${key2}/value`
    )
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error fetching data: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          const propertyItems = [];
          const collectionIdShorts = [];
          data.forEach(item => {
            if (item.modelType && item.modelType.name) {
              if (item.modelType.name === 'Property') {
                propertyItems.push({ name: item.idShort, value: item.value ?? null });
              }
              if (item.modelType.name === 'SubmodelElementCollection') {
                collectionIdShorts.push(item.idShort);
              }
            }
          });
          setLength(data.length);
          setParentSub(key1);
          setSecSubEele(key2);
          setListOfProperties(propertyItems);
          setListOfSecondLvlSub(collectionIdShorts);
        } else {
          setWhatAreweLookingAt("PROPERTY")
          setParentName(key1)
          setPropertyName(key2)
          setPropertyValue(data)
        }
      })
      .catch(error => {
        console.error("Failed to fetch data:", error);
      });
  }

}


export default App;

function deduplicateSubmodels(submodels, assetId = '') {
  const suffix = assetId ? '_' + assetId : '';
  const seen = new Set();
  return submodels.filter(sub => {
    const raw = sub.idShort || sub?.keys?.[0]?.value || '';
    // Throw away entries that are just suffixed duplicates (e.g. Documentation_rotor_Mo2)
    if (suffix && raw.endsWith(suffix)) return false;
    // Dedup remaining by name
    if (seen.has(raw)) return false;
    seen.add(raw);
    return true;
  });
}

function isEmptyObject(obj) {
  // If obj is not an object, it's a value, check if it's null or empty
  if (obj === null || obj === undefined || obj === "" || obj === "N/A") {
    return true;
  }

  // If obj is an array, loop through the array elements
  if (Array.isArray(obj)) {
    return obj.every(isEmptyObject); // Check if every element is empty
  }

  // If obj is an object, check its keys
  if (typeof obj === 'object') {
    return Object.keys(obj).every((key) => isEmptyObject(obj[key]));
  }

  // If it's a value that's not an object or array, return false (non-empty)
  return false;
}


function isAllEmpty(data) {
  // If the data is an array, recursively check each element
  if (Array.isArray(data)) {
    // Check each element in the array
    return data.every(item => isAllEmpty(item)); // Return true if all items are empty
  }

  // If the data is an object, recursively check its values
  if (typeof data === 'object' && data !== null) {
    // If it's a simple object, we need to check its 'value' field
    if (data.hasOwnProperty('value')) {
      return isAllEmpty(data.value); // Check if 'value' field is empty or null
    }
    // Recursively check all values of the object if it's more complex
    return Object.values(data).every(value => isAllEmpty(value));
  }

  // If it's a primitive value (string, number, etc.), check if it's an empty string or null
  return data === null || data === '' || data === 'N/A';
}

function checkInnerArrays(allMySubDetails) {
  // Iterate over the outer array
  return allMySubDetails.map((innerArray, index) => {
    if (!Array.isArray(innerArray)) return { index, isEmpty: true };
    // For each inner array, check if all values are empty
    const isEmpty = innerArray.every(submodel => isAllEmpty(submodel?.value));

    // Return the index with the result (true or false)
    
    return { index, isEmpty };
  });
}

// function fixDataForBasyx() {
//   //var images=incomingImages;
//   var general_info = incomingData.data[0].attributes;
//   var specific_info = incomingData.included;
//   //idShort = `${general_info["model"]}_${Math.floor(Math.random() * 9) + 1}` + `${Math.floor(Math.random() * 9) + 1}98${Math.floor(Math.random() * 9) + 1}3${Math.floor(Math.random() * 9) + 1}7${Math.floor(Math.random() * 9) + 1}4${Math.floor(Math.random() * 9) + 1}6${Math.floor(Math.random() * 9) + 1}7`;
//   idShort = `${general_info["model"]}`

//   if (typeof uuID === "undefined") {
//     //alert("UN")
//     uuID = `7165398751379457`;
//   }

//   diti = {
//     "conceptDictionary": [],
//     "identification": {
//       "idType": "Custom",
//       "id": `${uuID}`//`${idShort}`
//     },
//     "idShort": `${idShort}_${uuID}`,//`${name}`,
//     "dataSpecification": [],
//     "modelType": {
//       "name": "AssetAdministrationShell"
//     },
//     "asset": {
//       "identification": {
//         "idType": "Custom",
//         "id": `${idShort}`
//       },
//       "idShort": `${idShort}`,
//       "kind": "Instance",
//       "dataSpecification": [],
//       "modelType": {
//         "name": "Asset"
//       },
//       "embeddedDataSpecifications": []
//     },
//     "embeddedDataSpecifications": [],
//     "views": [],
//     "submodels": [
//       {
//         "keys": [
//           {
//             "type": "Submodel",
//             "idType": "Custom",
//             "value": "string",
//             "local": true
//           }
//         ]
//       }
//     ],
//   }




//   // upload();
//   setReRender(current => !current)
//   //CREATING THE ASSET---END


//   //___________CREATING IMAGE SUBMODEL________________//

//   for (let i = 0; i < images.length - 1; i++) {



//     if ((images[i].quality_classification.id).toString() === diti.identification.id) {
//       // alert("Hello Mother Fucker")
//       images_value.push(images[i].quality_classification.image)
//       emptySubmodel = {
//         "idShort": "Images",
//         "identification": {
//           "idType": "Custom",
//           "id": "pccaseimages"
//         },
//         "dataSpecification": [

//         ],
//         "embeddedDataSpecifications": [

//         ],
//         "modelType": {
//           "name": "Submodel"
//         },
//         "kind": "Instance",
//         "submodelElements": {

//         }
//       };

//       // createSubmodel(emptySubmodel.idShort, images_value);
//     }
//   }







//   //Creating NAmePLate
//   for (let keys in general_info) {
//     //console.log(keys, ":", general_info[keys])
//     if (keys === "idShort") {
//       infoNameplate[keys] = general_info[keys];
//     }
//     if (keys === "form_factor") {
//       infoNameplate[keys] = general_info[keys];
//     }
//     if (keys === "end_of_life") {
//       infoNameplate[keys] = general_info[keys];
//     }
//     if (keys === "model") {
//       infoNameplate[keys] = general_info[keys];
//     }
//     if (keys === "type") {
//       infoNameplate[keys] = general_info[keys];
//     }
//     if (keys === "uuid") {
//       infoNameplate[keys] = general_info[keys];
//     }
//   }

//   console.log(infoNameplate)
//   emptySubmodel = {
//     "idShort": "Nameplate",
//     "identification": {
//       "idType": "Custom",
//       "id": "nameplate"
//     },
//     "dataSpecification": [

//     ],
//     "embeddedDataSpecifications": [

//     ],
//     "modelType": {
//       "name": "Submodel"
//     },
//     "kind": "Instance",
//     "submodelElements": {

//     }
//   };
//   console.log(emptySubmodel.idShort)
//   // createSubmodel(emptySubmodel.idShort, infoNameplate);

//   for (let i = 0; i < specific_info.length; i++) {

//     if (
//       specific_info[i].type === "partition" ||
//       specific_info[i].type === "processor" ||
//       specific_info[i].type === "network" ||
//       specific_info[i].type === "motherboard" ||
//       specific_info[i].type === "memory" ||
//       specific_info[i].type === "usb" ||
//       specific_info[i].type === "sound" ||
//       specific_info[i].type === "video"
//     ) {
//       infoBOM[specific_info[i].type] = specific_info[i];
//     }
//   }
//   emptySubmodel = {
//     "idShort": "BOM",
//     "identification": {
//       "idType": "Custom",
//       "id": "billofmaterials"
//     },
//     "dataSpecification": [

//     ],
//     "embeddedDataSpecifications": [

//     ],
//     "modelType": {
//       "name": "Submodel"
//     },
//     "kind": "Instance",
//     "submodelElements": {

//     }
//   };
//   console.log(emptySubmodel.idShort)

//   // createSubmodel(emptySubmodel.idShort, infoBOM);

// }


// async function createSubmodel(submodelIDShort, setofElements) {
//   console.log(submodelIDShort)

//   var fixEdUrl = encodeURIComponent(`${diti.identification.id}`)
//   const mares = await fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodelIDShort}`, {
//     method: "PUT",
//     body: JSON.stringify(emptySubmodel),
//   })

//   //const result = await mares.json();
//   const status = await mares.status;
//   if (status === 200) {
//     addSubmodelElements(submodelIDShort, setofElements)
//   }
//   else {
//     console.error(mares)
//   }
//   //console.log(result)

// }

// function makeid(length, myKeys) {
//   let result = '';

//   // Include the first 5 characters from myKeys or all characters if myKeys is shorter
//   result += myKeys.substring(0, Math.min(6, myKeys.length));

//   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//   const charactersLength = characters.length;
//   let counter = result.length;

//   // Generate random characters to reach the desired length
//   while (counter < length) {
//     const randomChar = characters.charAt(Math.floor(Math.random() * charactersLength));
//     result += randomChar;
//     counter += 1;
//   }

//   //console.log(result, myKeys)
//   return result;
// }


// async function addSubmodelElements(subModelName, setofElements) {
//   console.log(subModelName, setofElements)
//   var submodelElement = {}



//   for (let keys in setofElements) {


//     if (typeof setofElements[keys] === "object") {
//       var value = [];


//       for (let myKeys in setofElements[keys]) {

//         if (typeof setofElements[keys][myKeys] === "object") {
//           var values2 = []
//           var sum = 0;
//           for (let tKeys in setofElements[keys][myKeys]) {

//             //var cur=tKeys+Math.random()


//             //var trial=myKeys+"_"+keys+"_"+tKeys;

//             var inner_inner = {}
//             inner_inner = {
//               "modelType": {
//                 "name": "Property"
//               },
//               "kind": "Instance",
//               "value": `${setofElements[keys][myKeys][tKeys]}`,//<== value
//               "valueType": "string",
//               "idShort": makeid(10, tKeys),
//               "parent": {
//                 "keys": [
//                   {
//                     "type": "SubmodelElementCollection",
//                     "local": true,
//                     "value": `${myKeys}`,
//                     "idType": "Custom"
//                   }
//                 ]
//               }
//             }


//             values2.push(inner_inner)
//             sum++;

//           }



//           var inner2 = {}
//           inner2 = {
//             "modelType": {
//               "name": "SubmodelElementCollection"
//             },
//             "kind": "Instance",
//             "value": values2,
//             "valueType": "string",
//             "idShort": `${myKeys}`,
//             "parent": {
//               "keys": [
//                 {
//                   "type": "Submodel",
//                   "local": true,
//                   "value": `${keys}`,
//                   "idType": "Custom"
//                 }
//               ]
//             }
//           }
//           // console.log("Upper",myKeys, keys ,inner2)
//           value.push(inner2)
//           // console.log("the value",myKeys, keys ,value)
//         }

//         else {

//           var inner = {}
//           inner = {
//             "modelType": {
//               "name": "Property"
//             },
//             "kind": "Instance",
//             "value": `${setofElements[keys][myKeys]}`,//<== value
//             "valueType": "string",
//             "idShort": `${myKeys}`,
//             "parent": {
//               "keys": [
//                 {
//                   "type": "Submodel",
//                   "local": true,
//                   "value": `${setofElements[keys]}`,
//                   "idType": "Custom"
//                 }
//               ]
//             }
//           }


//           value.push(inner)

//         }



//       }
//       console.log(value)
//       submodelElement = {
//         "modelType": {
//           "name": "SubmodelElementCollection"
//         },
//         "kind": "Instance",
//         "value": value,//<== value
//         "valueType": "string",
//         "idShort": `${keys}`,
//         "parent": {
//           "keys": [
//             {
//               "type": "Submodel",
//               "local": true,
//               "value": `${subModelName}`,
//               "idType": "Custom"
//             }
//           ]
//         }
//       }


//     }




//     else {
//       submodelElement = {
//         "modelType": {
//           "name": "Property"
//         },
//         "kind": "Instance",
//         "value": `${setofElements[keys]}`,//<== value
//         "valueType": "string",
//         "idShort": `${keys}`,
//         "parent": {
//           "keys": [
//             {
//               "type": "Submodel",
//               "local": true,
//               "value": `${subModelName}`,
//               "idType": "Custom"
//             }
//           ]
//         }
//       }
//     }





//     var fixedSubModelElement = encodeURIComponent(submodelElement.idShort);

//     var fixEdUrl = encodeURIComponent(`${diti.identification.id}`)
//     fixedForTExt = fixEdUrl
//     const mares = await fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${subModelName}/submodel/submodelElements/${fixedSubModelElement}`, {
//       method: "PUT",
//       body: JSON.stringify(submodelElement),
//     })

//     //const result = await mares.json();
//     //console.log(mares)

//     const status = mares.status;

//     if (status === 200 && subModelName) {
//       //console.log("We are A BOM")
//       // for (let keys in setofElements) {
//       //   console.log(keys, ":", setofElements[keys])


//       //   if (typeof setofElements[keys] !=="object")
//       //   {
//       //     const mares = await fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${subModelName}/submodel/submodelElements/${keys}/value`, {
//       //       headers: {
//       //         "Content-Type": "application/json",
//       //       },
//       //       method: "PUT",
//       //       body: JSON.stringify(setofElements[keys]),

//       //     })
//       //   }


//       // }
//     }

//   }

// }
// const diti2 = {
//   "idShort": "BOM",
//   "modelType": {
//     "name": "Submodel"
//   },
//   "identification": {
//     "id": "trial_ID/instance/12345",
//     "idType": "Custom"
//   },
//   "embeddedDataSpecifications": [],
//   "qualifiers": [],
//   "semanticId": {
//     "keys": [
//       {
//         "type": "GlobalReference",
//         "idType": "Custom",
//         "value": "the Value",
//         "local": false
//       }
//     ]
//   },
//   "kind": "Instance",
//   "submodelElements": [
//     {
//       "idShort": "motherboard",
//       "category": "item",
//       "description": [
//         {
//           "language": "string",
//           "text": "string"
//         }
//       ],
//       "parent": {
//         "keys": [
//           {
//             "type": "Asset",
//             "idType": "Custom",
//             "value": "string",
//             "local": true
//           }
//         ]
//       },
//       "modelType": {
//         "name": "Asset"
//       },
//       "embeddedDataSpecifications": [],
//       "kind": "Template"
//     }
//   ]
// }

// async function upload() {
//   //console.log(diti)

//   var fixEdUrl = encodeURIComponent(`${diti.identification.id}`)
//   const mares = await fetch(`/aasServer/shells/${fixEdUrl}`, {
//     method: "PUT",
//     body: JSON.stringify(diti),
//   })

//   const res = await mares.status;


//   if (res === 200) {
//     setReRender(current => !current)
//     // const mares = await fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/Service/submodel`, {
//     //   method: "PUT",
//     //   body: JSON.stringify(diti2),
//     // })
//     // console.log(mares.json())
//     createTheAsset()
//   }
//   else {
//     console.log(mares)
//   }

// }



// async function createTheAsset() {


//   var assetID = {

//     "@context": {
//       "edc": "https://w3id.org/edc/v0.0.1/ns/"
//     },
//     "@type": "edc:Asset",
//     "@id": `DPP_Revertia_${idShort}_${uuID}`,
//     "edc:properties": {
//       "edc:id": `DPP_Revertia_${idShort}_${uuID}`,
//       "edc:name": `DPP_Revertia_${idShort}_${uuID}`,
//       "edc:contenttype": "text/plain",
//       "edc:version": "1.0",
//       "edc:type": "AzureStorage"
//     },
//     "edc:dataAddress": {
//       "@type": "edc:DataAddress",
//       "edc:type": "AzureStorage",
//       "edc:properties": [
//         {
//           "edc:account": "company1assets",
//           "edc:container": "src-container",
//           "edc:blobname": `text-document.txt`,
//           "edc:keyName": "company1assets-key1"
//         }
//       ]
//     }

//   }
//   var policyID = {
//     "@context": {
//       "@vocab": "https://w3id.org/edc/v0.0.1/ns/",
//       "odrl": "http://www.w3.org/ns/odrl/2/"
//     },
//     "@id": `policy_${idShort}`,
//     "policy": {
//       "@type": "set",
//       "odrl:permission": [
//         {
//           "http://www.w3.org/ns/odrl/2/action": [
//             {
//               "http://www.w3.org/ns/odrl/2/type": [
//                 {
//                   "@value": "http://www.w3.org/ns/odrl/2/use"
//                 }
//               ]
//             }
//           ],
//           "http://www.w3.org/ns/odrl/2/constraint": [
//             {
//               "http://www.w3.org/ns/odrl/2/leftOperand": [
//                 {
//                   "@value": "https://w3id.org/edc/v0.0.1/ns/regionLocation"
//                 }
//               ],
//               "http://www.w3.org/ns/odrl/2/operator": [
//                 {
//                   "@id": "http://www.w3.org/ns/odrl/2/eq"
//                 }
//               ],
//               "http://www.w3.org/ns/odrl/2/rightOperand": [
//                 {
//                   "@value": "eu"
//                 }
//               ]
//             }
//           ]
//         }
//       ],
//       "odrl:prohibition": [],
//       "odrl:obligation": []
//     }
//   }

//   var contractID = {
//     "@context": {
//       "@vocab": "https://w3id.org/edc/v0.0.1/ns/"
//     },
//     "@id": `DPP_Revertia_${idShort}_${uuID}`,
//     "accessPolicyId": `no-restriction-policy`,
//     "contractPolicyId": `no-restriction-policy`,
//     "assetsSelector": [
//       {
//         "operandLeft": "https://w3id.org/edc/v0.0.1/ns/id",
//         "operator": "in",
//         "operandRight": `DPP_Revertia_${idShort}_${uuID}`
//       },
//     ]
//   }
//   const fetchMe = await fetch(`http://128.140.98.108:9191/api/management/v3/assets`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-api-key": "ApiKeyDefaultValue"

//       },
//       body: JSON.stringify(assetID)
//     })

//   const result = await fetchMe.status;

//   if (result === 200) {
    
//     const fetchMe = await fetch(`http://128.140.98.108:9191/api/management/v2/contractdefinitions`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-api-key": "ApiKeyDefaultValue"

//         },
//         body: JSON.stringify(contractID)
//       })

//     const result = await fetchMe.status;
//     const myRes = await fetchMe.json()

//     if (result === 200) {
//       alert("Asset, Policy and Contract added.")
//       const fetchAllforTex = await fetch(
//         `/aasServer/shells/${fixedForTExt}/aas/submodels`
//       )
//       const resultForText = await fetchAllforTex.status;
//       const myResForText = await fetchAllforTex.json()

//       handleSubmit(myResForText)
//     }
//     else {
//       console.log(myRes)
//       alert("contract error")
//     }

//     //}

//   }
//   else {
//     alert("policy error")
//   }
//   setName("");
//   setContractIDstate("");
//   setPolicyIDstate("");
// }